import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { ErrorBoundary } from './ErrorBoundary';
import Wizard from './components/wizard/Wizard';
import Layout from './components/layout/Layout';
import { LanguageDetection, useBrowserLanguage } from './components/languageDetection/';

const App = () => {
  const browserLanguage = useBrowserLanguage();
  return (
    <Router basename='/license-wizard'>
      <Routes>
        <Route path="/" element={<Navigate replace to={'/' + browserLanguage} />} />
        <Route path="/:locale" >
          <Route index element={
            <LanguageDetection>
              <Layout>
                <ErrorBoundary>
                  <HelmetProvider>
                    <Wizard />
                  </HelmetProvider>
                </ErrorBoundary>
              </Layout>
            </LanguageDetection>
          }
          />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;